import { render, staticRenderFns } from "./KitsAccessories.vue?vue&type=template&id=753595dc&scoped=true"
import script from "./KitsAccessories.vue?vue&type=script&lang=js"
export * from "./KitsAccessories.vue?vue&type=script&lang=js"
import style0 from "./KitsAccessories.vue?vue&type=style&index=0&id=753595dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753595dc",
  null
  
)

export default component.exports